class UtilsService {
  getDeepValue(source, field) {
    field = field.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    field = field.replace(/^\./, ''); // strip a leading dot
    const path = field.split('.');
    for (let i = 0, n = path.length; i < n; ++i) {
      const partName = path[i];
      if (source && partName in source) {
        source = source[partName];
      } else {
        return;
      }
    }
    return source;
  }
}

const utilsService = new UtilsService();
export default utilsService;
